/**
 * @description 图片原图加载
 */

//  已经下载的图片缓存
const LOADED_BUFFER: { [key: string]: boolean } = {};
// 下载过程中关闭了gallery组件的
const LOAD_CANCELED: { [key: string]: boolean } = {};

interface IImgOriginalLoaderCallback {
    onSuccess?: () => void;
    onError?: () => void;
}

export default class ImgOriginalLoader {
    public static load(url: string, options: IImgOriginalLoaderCallback = {}) {
        if (LOADED_BUFFER[url]) {
            ImgOriginalLoader.onSuccess(url, options.onSuccess);
            return;
        }

        const src = url;
        const loader = new Image();

        loader.onerror = loader.onabort = () => {
            ImgOriginalLoader.onError(url, options.onError);
        };

        loader.onload = () => {
            ImgOriginalLoader.onSuccess(url, options.onSuccess);
        };

        loader.src = src;
    }

    public static onSuccess(url: string, onSuccess?: () => void) {
        LOADED_BUFFER[url] = true;
        // 下载过程中关闭了gallery组件的，不执行回调
        if (onSuccess && !LOAD_CANCELED[url]) {
            onSuccess();
        }
        delete LOAD_CANCELED[url];
    }

    public static onError(_url: string, onError?: () => void) {
        if (onError) {
            onError();
        }
    }

    public static cancel(url: string) {
        LOAD_CANCELED[url] = true;
    }

    public static has(url: string) {
        return LOADED_BUFFER[url];
    }
}
